// extracted by mini-css-extract-plugin
module.exports = {"addWrap":"Groups_addWrap__2p2Se","addNew__icon":"Groups_addNew__icon__16y4Q","addNew__text":"Groups_addNew__text__2GSKF","goBack__icon":"Groups_goBack__icon__WTPna"};